// eslint-disable-next-line import/no-cycle
import investmentService from '@client/services/investment';

export const allocationByPortId = async (segmentgoalId, interpretedRisk, targetDate) => {
  const allocation = await investmentService.getAllocationByPortId({
    portId: segmentgoalId,
    riskTolerance: interpretedRisk,
    targetDate,
  });

  return allocation;
};

export const allocationByGoalId = async (segmentgoalId, interpretedRisk, targetDate) => {
  const allocation = await investmentService.getAllocationByGoalId({
    goalId: segmentgoalId,
    riskTolerance: interpretedRisk,
    targetDate,
  });

  return allocation;
};

export const riskAllocationByPortId = async (interpretedRisk) => {
  const allocation = await investmentService.getRiskAllocationByPortId({
    riskTolerance: interpretedRisk,
  });

  return allocation;
};

export const allocationByModel = async (userPortfolioType, segmentgoalId, interpretedRisk, targetDate) => {
  const allocation =
    userPortfolioType === 'RISK_BASED_PORTFOLIO'
      ? await riskAllocationByPortId(interpretedRisk)
      : await allocationByPortId(segmentgoalId, interpretedRisk, targetDate);

  return allocation;
};

export const allocationByGoalModel = async (userPortfolioType, segmentgoalId, interpretedRisk, targetDate) => {
  const allocation =
    userPortfolioType === 'RISK_BASED_PORTFOLIO'
      ? await riskAllocationByPortId(interpretedRisk)
      : await allocationByGoalId(segmentgoalId, interpretedRisk, targetDate);

  return allocation;
};
